<template>
  <Swiper
    :slides-per-view="1"
    :navigation="true"
    :lazy="true"
    :observer="true"
    :observeParents="true"
  >
    <SwiperSlide v-for="(image, index) in images" :key="index">
      <img
        v-if="image.Src !== null"
        :alt="image.Alt"
        :data-src="imageSrcOrigin + image.Src"
        class="swiper-lazy"
      />
      <div class="swiper-lazy-preloader"></div>
    </SwiperSlide>
  </Swiper>
</template>

<script>
import SwiperCore, { Navigation, Lazy } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";

SwiperCore.use([Navigation, Lazy]);

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    images: Array,
  },
  computed: {
    windowOrigin() {
      return window.location.origin;
    },
  },
};
</script>

<style lang="scss">
.swiper-button-next,
.swiper-button-prev {
  text-align: center;
  width: 60px !important;
  height: 60px !important;
  -webkit-border-radius: 60px;
  border-radius: 60px;
  background-color: rgba(141, 175, 202, 0.8);
  z-index: 2;
  -webkit-transition: top 0.2s linear;
  transition: top 0.2s linear;
  @apply tw-text-white;
  &:after {
    font-size: 30px !important;
  }
  &:hover {
    background-color: #195483;
  }
}
.swiper-button-prev:after {
  margin-left: -5px;
}
.swiper-button-next:after {
  margin-right: -5px;
}
</style>
